<script>

    import SelectorWidget from './SelectorWidget';

    export default SelectorWidget.extend({

        methods: {
            render() {
                this.iteration += 1;
                this.setValue();
            }
        }

    });

</script>
